// 最大安全数字
export const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
// 最小安全数字
export const MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;